(() => {
 if (customElements.get('oww-mobile-product-groups')) return;
 class OwwMobileProductGroups extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.dialog = this.querySelector('dialog');
   this.opener = this.querySelector('[data-oww-groups-open]');
   this.filterButton = this.querySelector('[data-oww-native-filters]');
   if (!this.dialog?.showModal) return;
   this.section = this.closest('.shopify-section') || document;
   this.setAttribute('data-ready', '');
   document.documentElement.classList.add('oww-mobile-groups-ready');
   this.opener.addEventListener('click', () => {
    if (this.dialog.open) { this.dialog.close(); return; }
    this.closeFilters();
    this.syncDesktopLayout();
    if (this.desktop()) this.dialog.show(); else this.dialog.showModal();
    this.opener.setAttribute('aria-expanded','true');
    document.body.classList.add('oww-product-groups-open');
   });
   this.querySelector('[data-oww-groups-close]').addEventListener('click', () => this.dialog.close());
   this.dialog.addEventListener('close', () => {
    document.body.classList.remove('oww-product-groups-open');
    this.opener.setAttribute('aria-expanded','false');
    this.opener.focus({preventScroll:true});
   });
   this.dialog.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (link) this.dialog.close();
    if (event.target === this.dialog && event.clientX > this.dialog.getBoundingClientRect().right) this.dialog.close();
   });
   this.filterButton.addEventListener('click', () => {
    if (this.dialog.open) this.dialog.close();
    this.syncDesktopLayout();
    const native = this.nativeFilter();
    if (native) native.click();
   });
   this.syncFilters = () => {
    const native = this.nativeFilter();
    this.filterButton.hidden = !native;
    if (native) native.setAttribute('data-oww-proxied', '');
   };
   this.syncFilters();
   this.observer = new MutationObserver(() => this.syncFilters());
   this.observer.observe(this.section, {childList:true,subtree:true});
   this.lastFilterOpen = false;
   this.detailObserver = new MutationObserver((records) => {
    for (const record of records) {
     if (!record.target.matches('details.mobile-facets__disclosure')) continue;
     const isOpen = record.target.hasAttribute('open');
     this.toggleAttribute('data-filters-open', isOpen);
     this.filterButton.setAttribute('aria-expanded', String(isOpen));
     if (this.lastFilterOpen && !isOpen) requestAnimationFrame(() => this.filterButton.focus({preventScroll:true}));
     this.lastFilterOpen = isOpen;
    }
   });
   this.detailObserver.observe(this.section, {attributes:true,attributeFilter:['open'],subtree:true});
   // The marker stays in normal flow; resizing the sticky bar must not move products.
   this.flowMarker = document.createElement('span');
   this.flowMarker.className = 'oww-mobile-tools__marker';
   this.flowMarker.setAttribute('aria-hidden', 'true');
   this.before(this.flowMarker);
   let ticking = false;
   this.updateTop = () => {
    const header = document.querySelector('.section-header');
    const hidden = header?.classList.contains('shopify-section-header-hidden') && !header.classList.contains('menu-open');
    const sticky = header?.classList.contains('shopify-section-header-sticky');
    const bottom = !header || hidden ? 0 : sticky ? header.offsetHeight : Math.max(0,header.getBoundingClientRect().bottom);
    const top = Math.min(bottom,window.innerHeight/2);
    this.style.setProperty('--oww-tools-top', top + 'px');
    const wasCompact = this.hasAttribute('data-compact');
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const markerTop = this.flowMarker.getBoundingClientRect().top;
    // A four-pixel return band avoids flicker around the pinning point.
    const compact = mobile && (wasCompact ? markerTop <= top + 4 : markerTop < top - 1);
    if (compact !== wasCompact) {
     if (compact) {
      this.expandedHeight = this.getBoundingClientRect().height;
      this.style.setProperty('--oww-tools-base-margin', getComputedStyle(this).marginBottom);
     }
     this.toggleAttribute('data-compact', compact);
     if (compact) {
      const reclaimed = Math.max(0, this.expandedHeight - this.getBoundingClientRect().height);
      this.style.setProperty('--oww-tools-reclaimed', reclaimed + 'px');
     } else {
      this.style.removeProperty('--oww-tools-reclaimed');
      this.style.removeProperty('--oww-tools-base-margin');
     }
    }
    this.syncDesktopLayout();
    ticking = false;
   };
   this.onScroll = () => {
    if (!ticking) { ticking = true; requestAnimationFrame(this.updateTop); }
   };
   window.addEventListener('scroll',this.onScroll,{passive:true});
   window.addEventListener('resize',this.onScroll);
   this.headerObserver = new ResizeObserver(this.onScroll);
   const header = document.querySelector('.section-header');
   if (header) {
    this.headerObserver.observe(header);
    this.headerClassObserver = new MutationObserver(this.onScroll);
    this.headerClassObserver.observe(header,{attributes:true,attributeFilter:['class']});
   }
   this.onOutside = (event) => {
    if (!this.desktop()) return;
    if (this.dialog.open && !this.dialog.contains(event.target) && !this.opener.contains(event.target)) this.dialog.close();
    const details = this.filterDetails();
    if (details?.open && !details.contains(event.target) && !this.filterButton.contains(event.target)) this.closeFilters();
   };
   this.onEscape = (event) => { if (event.key === 'Escape' && this.dialog.open) this.dialog.close(); };
   document.addEventListener('pointerdown', this.onOutside);
   document.addEventListener('keydown', this.onEscape);
   this.updateTop();
  }

  desktop() { return window.matchMedia('(min-width: 990px)').matches; }
  filterDetails() { return this.section.querySelector('details.mobile-facets__disclosure'); }
  closeFilters() {
   const details = this.filterDetails();
   if (details?.open) details.closest('menu-drawer').closeMenuDrawer(new Event('click'), this.filterButton);
  }
  positionPanel(panel, button, width, right = false) {
   const rect = button.getBoundingClientRect();
   const top = rect.bottom + 8;
   const left = Math.max(12, Math.min(right ? rect.right - width : rect.left, innerWidth - width - 12));
   panel.style.setProperty('--oww-popover-left', left + 'px');
   panel.style.setProperty('--oww-popover-top', top + 'px');
   panel.style.setProperty('--oww-popover-height', Math.max(120, innerHeight - top - 16) + 'px');
  }
  syncDesktopLayout() {
   const desktop = this.desktop();
   if (this.lastDesktop !== undefined && desktop !== this.lastDesktop) {
    if (this.dialog.open) this.dialog.close();
    this.closeFilters();
   }
   this.lastDesktop = desktop;
   if (!this.heading) {
    this.heading = document.querySelector('h1.collection-hero__title');
    this.headingSection = this.heading?.closest('.shopify-section');
    if (this.heading) {
     this.headingHome = document.createComment('Collection heading');
     this.heading.before(this.headingHome);
    }
   }
   if (this.heading) {
    this.headingSection?.classList.toggle('oww-title-in-tools', desktop);
    if (desktop && this.heading.parentElement !== this.querySelector('.oww-mobile-tools__bar')) this.querySelector('.oww-mobile-tools__bar').prepend(this.heading);
    if (!desktop && this.headingHome.nextSibling !== this.heading) this.headingHome.after(this.heading);
   }
   if (desktop) {
    this.positionPanel(this.dialog, this.opener, 440);
    const filters = this.section.querySelector('.mobile-facets');
    if (filters) this.positionPanel(filters, this.filterButton, 400, true);
   }
  }

  nativeFilter() { return this.section.querySelector('.mobile-facets__open-wrapper'); }
  disconnectedCallback() {
   this.flowMarker?.remove();
   document.removeEventListener('pointerdown',this.onOutside); document.removeEventListener('keydown',this.onEscape);
   if (this.headingHome?.isConnected) this.headingHome.after(this.heading);
   this.headingHome?.remove();
   this.headingSection?.classList.remove('oww-title-in-tools');
   this.observer?.disconnect(); this.detailObserver?.disconnect(); this.headerObserver?.disconnect(); this.headerClassObserver?.disconnect();
   window.removeEventListener('scroll',this.onScroll); window.removeEventListener('resize',this.onScroll);
  }
 }
 customElements.define('oww-mobile-product-groups',OwwMobileProductGroups);
})();
